<template>
  <div class="shelf-logo" :class="$attrs.class" :style="{ height: logoHeight }" role="img" :aria-label="alt">
    <picture>
      <source
        type="image/webp"
        :srcset="`${whiteTextLogo360} 360w, ${whiteTextLogo720} 720w, ${whiteTextLogo1280} 1280w`"
        sizes="(max-width: 600px) 360px, (max-width: 1200px) 720px, 1280px"
      />
      <img :src="whiteTextLogo" :alt="alt" class="shelf-logo__art" width="1380" height="676" />
    </picture>
    <span class="shelf-logo__text" :style="{ ...textMaskStyle, backgroundColor: textColor }" aria-hidden="true" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useTheme } from 'vuetify'
import { useUserStore } from '@/stores/userStore'
import whiteTextLogo from '@/assets/ShelfLogoV6-WhiteText.png'
import whiteTextLogo360 from '@/assets/ShelfLogoV6-WhiteText-360.webp'
import whiteTextLogo720 from '@/assets/ShelfLogoV6-WhiteText-720.webp'
import whiteTextLogo1280 from '@/assets/ShelfLogoV6-WhiteText-1280.webp'
import textMask from '@/assets/ShelfLogoV6-TextMask-720.webp'

const props = withDefaults(defineProps<{ alt?: string; height?: string | number }>(), {
  alt: 'Shelf Logo'
})

const userStore = useUserStore()
const theme = useTheme()

const textColor = computed(() => {
  const isDark = theme.global.current.value.dark
  const colors = userStore.colors
  return isDark
    ? colors?.logoDarkText ?? '#fff'
    : colors?.logoLightText ?? '#222'
})

const logoHeight = computed(() => props.height === undefined ? undefined : `${props.height}${typeof props.height === 'number' ? 'px' : ''}`)

const textMaskStyle = {
  maskImage: `url(${textMask})`,
  WebkitMaskImage: `url(${textMask})`
}
</script>

<style scoped>
.shelf-logo {
  position: relative;
  display: inline-block;
  line-height: 0;
  aspect-ratio: 1380 / 676;
  box-sizing: border-box;
  padding: 0 !important;
  overflow: hidden;
}

.shelf-logo__art {
  display: block;
  width: 100%;
  height: auto;
}

.shelf-logo picture {
  display: block;
}

.shelf-logo__text {
  display: block;
}

.shelf-logo__text {
  position: absolute;
  inset: 0;
  background-color: #222;
  mask-mode: alpha;
  mask-position: center;
  mask-repeat: no-repeat;
  mask-size: 100% 100%;
  -webkit-mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: 100% 100%;
  pointer-events: none;
}
</style>
